__turbopack_context__.v({
  "additionalInfo": "o178cW_additionalInfo",
  "roomTypes": "o178cW_roomTypes",
  "rooms": "o178cW_rooms",
});
